export default {
    props: [
        'index',
        'method',
        'chosenMethod',
    ],

    computed: {
        methodName() {
            if (this.method === 'PASSPORT') {
                return this.$i18nApi.t('checkout6.passport');
            }

            if (this.method === 'ID') {
                return this.$i18nApi.t('checkout6.id');
            }

            if (this.method === 'DRIVINGLICENCE') {
                return this.$i18nApi.t('checkout6.drivingLicence');
            }

            if (this.method === 'VISA') {
                return this.$i18nApi.t('checkout6.visa');
            }

            if (this.method === 'Meldezettel') {
                return this.$i18nApi.t('checkout6.meldezettel');
            }

            if (this.method === 'Anmeldebescheinigung') {
                return this.$i18nApi.t('checkout6.anmeldebescheinigung');
            }

            if (this.method === 'RESIDENCE_PERMIT') {
                return this.$i18nApi.t('checkout6.residencePermit');
            }

            return this.method;
        }
    },

    methods: {
        clicked(clickedMethod) {
            this.$emit('updateClickedMethod', clickedMethod);
        },
    },
}
